import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { HelperService, ToastrService } from '../services/index.service';
@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    public helperService: HelperService,
    private router: Router,
    private toastrService: ToastrService,
  ) {
  }
  userObj: any;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.userObj = this.helperService.getLocalStorage('userObj');
    console.log("Can Activated")
    if (this.userObj && Object.keys(this.userObj).length > 0) {
     this.router.navigate(['/portal/shipping']);
      return false;
    }
    else {
      return true;
    }
  }
}


